'use es6';

import HubDbRows from '../models/HubDbRows';
import { RECEIVED_HUBDB_ROWS, REQUESTED_HUBDB_ROWS_FAILED, REQUESTED_HUBDB_ROWS } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new HubDbRows(), action) => {
  switch (action.type) {
    case REQUESTED_HUBDB_ROWS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_HUBDB_ROWS:
      return action.payload.hubDbRows;
    case REQUESTED_HUBDB_ROWS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});